import { App } from 'vue';
import VueKeyCloak from '@dsb-norge/vue-keycloak-js';
import { useUserStoreWithOut } from '/@/store/modules/user';
import { useGlobSetting } from '/@/hooks/setting';

const initKeyCloak = async (app: App<Element>) => {
  const { kcUrl, kcRealm, kcClientId } = useGlobSetting();
  return new Promise((resolve) => {
    app.use(VueKeyCloak, {
      config: {
        realm: kcRealm,
        url: kcUrl,
        clientId: kcClientId,
      },
      init: {
        responseMode: 'query',
        onLoad: 'check-sso',
        checkLoginIframe: false,
      },
      onReady: async (kc) => {
        // initUserInfo
        const userStore = useUserStoreWithOut();
        // save
        userStore.setKeyCloak(kc);
        userStore.setToken(kc.token);
        await userStore.afterLoginAction(false);
        resolve(kc);
      },
    });
  });
};

export async function setupKeyCloak(app: App<Element>) {
  await initKeyCloak(app);
}
